"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityCompetitors = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
let OpportunityCompetitors = class OpportunityCompetitors {
    constructor(id, opportunityId, competitor, competitorId, competitorBranchId) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.competitor = competitor;
        this.competitorId = competitorId;
        this.competitorBranchId = competitorBranchId;
    }
};
exports.OpportunityCompetitors = OpportunityCompetitors;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCompetitors.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCompetitors.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "competitor", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], OpportunityCompetitors.prototype, "competitor", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "competitor_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCompetitors.prototype, "competitorId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "competitor_branch_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCompetitors.prototype, "competitorBranchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.opportunityId, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityCompetitors.prototype, "opportunity", void 0);
exports.OpportunityCompetitors = OpportunityCompetitors = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_competitor"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, String, Number, Number])
], OpportunityCompetitors);
